/* The service for the support feature */

import { db } from "../firebase"

export const sendSupportTicket = (args: { type: "report" | "help" | "contact", error_message: string, feature: string, document?: string, doc_id?: string, doc_ref?: firebase.default.firestore.DocumentReference, user_sender: string, navigation_location?: Object, extra?: any }) => {
    return db.collection("support").add(args);
}